import { useQuery } from "@tanstack/react-query";
import { fetchCategoryFolders } from "../services/fetchCategoryFolders";

/**
 * Custom hook to fetch category folders using TanStack Query v5.
 * Returns query result including data, loading, and error states.
 */
export function useCategoryFolders(departmentId) {
  return useQuery({
    queryKey: ["categoryFolders", departmentId],
    queryFn: () => fetchCategoryFolders(departmentId),
    staleTime: 5 * 60 * 1000, // cache data for 5 minutes
    refetchOnWindowFocus: false,
  });
}
